<script setup lang="ts">
defineProps<{ title: string; to: string; img?: string; copy?: string }>()
</script>

<template>
  <div class="group relative overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
    <!-- Image/Placeholder with modern styling -->
    <div class="relative h-48 w-full overflow-hidden bg-gradient-to-br from-slate-100 to-slate-200">
      <div v-if="!img" class="flex h-full w-full items-center justify-center p-6">
        <div class="text-center">
          <div class="mx-auto mb-3 h-12 w-12 rounded-full bg-primary-main/10 flex items-center justify-center">
            <svg class="h-6 w-6 text-primary-main" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <p class="text-slate-600 font-medium text-sm">{{ title }}</p>
        </div>
      </div>
      <img v-else :src="img" :alt="title" class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
      
      <!-- Overlay gradient -->
      <div class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </div>

    <!-- Content with better spacing and typography -->
    <div class="p-6">
      <h3 class="text-xl font-bold text-slate-900 mb-3 group-hover:text-primary-main transition-colors duration-200">
        {{ title }}
      </h3>
      <p class="text-slate-600 text-sm leading-relaxed mb-4">
        {{ copy || 'Full-service hauling & responsible disposal.' }}
      </p>
      
      <!-- Modern button with hover effects -->
      <div class="flex items-center justify-between">
        <NuxtLink 
          :to="to" 
          class="inline-flex items-center text-primary-main hover:text-primary-dark font-semibold text-sm transition-colors duration-200 group/link"
        >
          Learn more
          <svg class="ml-1 h-4 w-4 transform transition-transform duration-200 group-hover/link:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </NuxtLink>
        
        <!-- Service icon indicator -->
        <div class="h-8 w-8 rounded-full bg-primary-main/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <svg class="h-4 w-4 text-primary-main" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
